export enum CaseStatus {
  /**
   * Capitalized values(some with space) comes from SF.
   * We should keep them capitalized so its consistence between BS and SF
   */
  Approved = 'Approved',
  AwaitingCustomerFeedback = 'Awaiting Customer Feedback',
  AwaitingPhotos = 'Awaiting Photos',
  AwaitingReturn = 'Awaiting Return',
  Closed = 'Closed',
  Declined = 'Declined',
  InProgress = 'In Progress',
  New = 'New',
  WaitingForApproval = 'Waiting for Approval',

  /**
   * Custom BS status
   */
  Error = 'error',
  FailedToSubmitReturn = 'failed_to_submit_return_order',
  NotSubmitted = 'not_submitted',
  Submitting = 'submitting',
  Retry = 'retry',
  MaxRetryReached = 'max_retry_reached',
}
